import React from 'react';
import { ArzatorAltepInstructions } from './../TabsContent/ArzatorAltepTabs'

const Instructions = (props) => {
      switch (props.productId) {
        case 0:
          return <ArzatorAltepInstructions />
        default: 
          return <></>
      }
};

export default Instructions;
